import { Row, Col } from 'antd';
import clsx from 'clsx';
import { AddYearValues } from './index';
import { LocationYears } from 'models/ActivityDataLocationYears/locationYears.model';
import React from 'react';
import { monthList } from 'views/CompanySetup/companySetupConstants';
import { IncompleteIcon } from './activityDataEntry.util';
import { Location } from 'models/ActivityDataEntryLocation/location.model';

export const getInitialValues = (
  startMonth: string,
  baseYear: number,
  endMonth: string
): AddYearValues => ({
  fromMonth: startMonth,
  fromYear: baseYear?.toString(),
  toMonth: endMonth,
  toYear:
    startMonth === monthList?.[0]?.label
      ? baseYear?.toString()
      : (baseYear + 1)?.toString(),
});

export const getYearLabel = (
  year: LocationYears,
  startMonth: string,
  endMonth: string,
  filteredLocations: LocationYears[],
  isEditViewComponent: boolean,
  handleDeleteYear: (year?: number) => () => Promise<void>,
  deleteLoading: boolean,
  deleteLocationYearTitle: string,
  stopBubbling: () => void,
  styles: { [key: string]: string },
  OptionsDropdown: React.FC<any>
) => {
  let endYear = Number(year.year) + 1;
  if (startMonth === monthList?.[0]?.label && year?.year) {
    endYear = year?.year;
  }
  const isIncomplete = !year.status;
  return (
    <Row
      className={clsx(styles.tabLabel, {
        [styles.incomplete]: isIncomplete,
      })}>
      <Col>{`${startMonth} ${year.year} - ${endMonth} ${endYear}`}</Col>
      {isIncomplete && (
        <Col className={styles.alertIcon}>{<IncompleteIcon />}</Col>
      )}
      {filteredLocations?.length > 1 && !isEditViewComponent ? (
        <Col onClick={stopBubbling}>
          <OptionsDropdown
            className={styles.activeTabDropdown}
            deleteModalprops={{
              deleteTitle: deleteLocationYearTitle,
              onDelete: handleDeleteYear(year.year),
              loading: deleteLoading,
            }}
          />
        </Col>
      ) : null}
    </Row>
  );
};

export const handleSubmit = async (
  values: AddYearValues,
  locationId: string | undefined,
  createYearForLocation: Function,
  setIsModalOpen: Function,
  setActiveYear: Function,
  setActiveScope: Function,
  initialScope: string,
  fetchLocation: Function,
  setParams: Function,
  isFirstFlow: boolean
) => {
  const response = await createYearForLocation(locationId, values.fromYear);
  if (!response) return;

  setIsModalOpen(false);
  setActiveYear(values.fromYear?.toString());
  setActiveScope(initialScope);
  await fetchLocation(Number(locationId));
  setParams(
    isFirstFlow
      ? { activeTab: values.fromYear, isEditView: true, isFirstFlow: true }
      : { activeTab: values.fromYear, isEditView: true },
    undefined,
    true
  );
};

export const handleTabChange = (
  key: string,
  isEditView: boolean,
  setIsAlert: Function,
  setIsModalOpen: Function,
  addYearButton: string,
  defaultYearTab: string,
  setActiveYear: Function,
  setParams: Function,
  isFirstFlow: boolean,
  scopeTab: string,
  initialScope: string,
  fetchYearForLocation: Function,
  locationId: string | undefined
) => {
  switch (true) {
    case Boolean(isEditView):
      setIsAlert(true);
      break;
    case key === addYearButton:
      setIsModalOpen(true);
      break;
    case key === defaultYearTab:
      setActiveYear(key);
      setParams(
        isFirstFlow
          ? { activeTab: key, isFirstFlow: true }
          : {
              activeTab: key,
            },
        undefined,
        true
      );
      break;
    default:
      setActiveYear(key);
      setParams(
        isFirstFlow
          ? { activeTab: key, isFirstFlow: true }
          : {
              activeTab: key,
            },
        undefined,
        true
      );
      fetchYearForLocation(locationId, key);
      break;
  }
};

export const handleYearChange = (
  value: string,
  setFieldValue: (
    field: string,
    value: string,
    shouldValidate?: boolean | undefined
  ) => void,
  startMonth: string,
  monthList: { label: string }[]
) => {
  let endYear = (Number(value) + 1).toString();
  if (startMonth === monthList?.[0]?.label) {
    endYear = value;
  }
  setFieldValue('toYear', value ? endYear : '');
};

export const handleProceedClick = (
  isEditView: boolean,
  setIsCancelModal: Function,
  isCompleted: boolean | undefined,
  setIsCompletedModal: Function,
  location: Location | undefined,
  processingFacility: string,
  setIsCreateProductModal: Function,
  redirectToCompanySetUp: Function,
  CompanySetUpTabHash: Record<string, string>
) => {
  switch (true) {
    case Boolean(isEditView):
      setIsCancelModal(true);
      break;
    case !isCompleted:
      setIsCompletedModal(true);
      break;
    case location?.locationCategory === processingFacility:
      setIsCreateProductModal(true);
      break;
    default:
      redirectToCompanySetUp(CompanySetUpTabHash.LOCATIONS)();
      break;
  }
};
